import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./seleted-attachments-mng.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./seleted-attachments-mng.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { AttachmentManagerConstants } from "../shared/constants/attachment-manager.constant";
import { AttachmentManagerService } from "../shared/services/attachment-manager.service";
import { SelectedApplicationService } from "../../../services/selected-application/selected-application.service";
import { SharedConstants } from "../../../constants/shared.constants";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
import { map } from "rxjs";
import { AppControllerService } from "src/app/app-controller.service";
let SeletedAttachmentsMngComponent = class SeletedAttachmentsMngComponent {
    attachmentManagerService;
    appController;
    selectedApplicationService;
    changeDetection;
    setSelectAttachmentRequired = true;
    jobId;
    projectCycleId;
    attachmentType;
    componentType;
    anonymousAccess = { anonymousDocumentAccess: false };
    selectAttachmentLbl = AttachmentManagerConstants.SELECT_ATTACHMENT_CTRL;
    addBtn = SharedConstants.SELECT_LABEL;
    notEmptyError = AttachmentManagerConstants.SELECT_ATTACHMENT_ERROR;
    submit;
    selectedAttachmentId;
    attachmentList;
    attachmentDropdown = new Array();
    showSelectValidationMsg = false;
    ClearAttachmentSubscription;
    getAttachmentsObservableSubscription;
    addSavedAttachmentSubscription;
    observable;
    constructor(attachmentManagerService, appController, selectedApplicationService, changeDetection) {
        this.attachmentManagerService = attachmentManagerService;
        this.appController = appController;
        this.selectedApplicationService = selectedApplicationService;
        this.changeDetection = changeDetection;
    }
    ngOnInit() {
        this.initializeData();
        this.addSavedAttachment();
        this.changeDetection.detectChanges();
        this.ClearAttachmentSubscription = this.attachmentManagerService.emitClearAttachment.subscribe((clean) => {
            this.selectedAttachmentId = undefined;
            this.submit = false;
        });
    }
    onBtnAddClicked() {
        this.submit = true;
        const selectedAttachment = this.attachmentList.find(a => a.id === +this.selectedAttachmentId);
        if (selectedAttachment) {
            if (this.anonymousAccess.allDocumentsSelectedAnonymousAccess) {
                selectedAttachment.allowAccess = true;
            }
            this.attachmentManagerService.selectSavedAttachment(selectedAttachment);
        }
    }
    initializeData() {
        //let observable: Observable<IAttachments>;
        if (this.componentType == SharedConstants.ADD_PROJECT_CYCLE_COMPONENT_TYPE || this.componentType == SharedConstants.EDIT_PROJECT_CYCLE_COMPONENT_TYPE) {
            if (this.attachmentType && this.projectCycleId)
                this.observable = this.attachmentManagerService.getPcAttachmentAttachments(this.projectCycleId, +this.appController.selectedModuleID).pipe(map(x => {
                    x.forEach(a => {
                        this.attachmentManagerService.selectSavedAttachment(a);
                    });
                    return x;
                }));
        }
        else
            this.observable = this.selectedApplicationService.getAttachmentsObservable(this.jobId, this.attachmentType ? this.attachmentType.toString() : null)
                .pipe(map(x => { return x.value; }));
        // tslint:disable-next-line:max-line-length
        this.getAttachmentsObservableSubscription = this.observable.subscribe(attachments => {
            this.attachmentList = attachments;
            this.attachmentDropdown = new Array();
            attachments.forEach(elment => {
                this.attachmentDropdown.push({
                    key: elment.id,
                    value: `${elment.attachmentType} - ${elment.fileName} - ${elment.revision}`
                });
            });
            this.attachmentDropdown?.sort((a, b) => a?.value.localeCompare(b.value));
            this.changeDetection.detectChanges();
            this.attachmentManagerService.listUpated(this.attachmentList);
        });
        this.changeDetection.detectChanges();
    }
    addSavedAttachment() {
        this.addSavedAttachmentSubscription = this.attachmentManagerService.emitSavedAttachment.subscribe((attachment) => {
            this.initializeData();
        });
    }
    static ctorParameters = () => [
        { type: AttachmentManagerService },
        { type: AppControllerService },
        { type: SelectedApplicationService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        setSelectAttachmentRequired: [{ type: Input }],
        jobId: [{ type: Input }],
        projectCycleId: [{ type: Input }],
        attachmentType: [{ type: Input }],
        componentType: [{ type: Input }],
        anonymousAccess: [{ type: Input }]
    };
};
SeletedAttachmentsMngComponent = __decorate([
    Component({
        selector: "app-seleted-attachments-mng",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SeletedAttachmentsMngComponent);
export { SeletedAttachmentsMngComponent };
